/**
 * 项目送审实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Row,
    Col,
    message,
    InputNumber,
    DatePicker,
    Input,
    Flex,
    Typography,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dayjs from 'dayjs';

const MODULENAME_URL = CNF.navItems[0].submenu[1].url;

const { TextArea } = Input;
const { Text } = Typography;

const Entity = (props) => {
    const { open, setOpen, record, refresh } = props;

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [auditDate, setAuditDate] = useState(currentDate);
    const [auditAmount, setAuditAmount] = useState(0);
    const [auditUnit, setAuditUnit] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setAuditDate(currentDate);
        setAuditAmount(0);
        setAuditUnit('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (open && record) {
            setAuditDate(record.audit_date ? record.audit_date : currentDate);
            setAuditAmount(record.audit_amount > 0 ? record.audit_amount : record.contract_amount);
            setAuditUnit(record.audit_unit);
        }
    }, [open, record]);


    const ok = () => {
        // 参数校验
        if (auditAmount <= 0) {
            messageApi.error('送审金额不能为零！');
            return;
        }
        if (auditUnit === '') {
            messageApi.error('审计单位不能为空！');
            return;
        }
        if (auditDate === '') {
            messageApi.error('送审时间不能为空！');
            return;
        }

        setLoading(true);

        // 执行操作
        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}/${record.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                action: CNF.actionName.TOAUDIT,
                audit_date: auditDate,
                audit_amount: auditAmount,
                audit_unit: auditUnit,
                description: description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))
    };

    return (
        <>
            {contextHolder}
            <Modal
                width={600}
                title={record ? record.name : ''}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={24}><Text>送审金额</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <InputNumber
                                style={{ width: '100%' }}
                                formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                min={0}
                                step='0.01'
                                value={auditAmount}
                                onChange={(value) => setAuditAmount(value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>审计单位</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                value={auditUnit}
                                onChange={(e) => setAuditUnit(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>送审时间</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <DatePicker
                                placeholder='请选择日期'
                                style={{ width: '100%' }}
                                value={dayjs(auditDate, 'YYYY-MM-DD')}
                                onChange={(_, dateString) => setAuditDate(dateString)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>备注</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                rows={2}
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity